import { render } from "./ServicesDetailsView.vue?vue&type=template&id=11728f8d"
import script from "./ServicesDetailsView.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsView.vue?vue&type=script&lang=js"

import "./ServicesDetailsView.vue?vue&type=style&index=0&id=11728f8d&scope=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__